<template>
<div class="MessagerModal">
    <transition v-if="showModalMessager" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
<!-- 
              <div class="modal-header">
                <slot name="header" >
                 <span style="font-weight: bold !important;"> {{modalTitle}} </span>
                </slot>
              </div> -->

              <!-- <div class="modal-body">
                <slot name="body">
                  <img style="width:100%" :src="modalImage" />
                </slot>
              </div> -->
              <div class="modal-body">
                <slot name="body">
                  <span>Bạn sẽ được di chuyển đến fanpage Facebook để được hỗ trợ order sản phẩm</span>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-danger" @click="closeMesage()">
                    Đóng
                  </button>
                  <button class="btn btn-primary" @click="moveToPage()">
                    Đồng ý
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</div>
</template>

<script>


export default {
    name: 'MessagerModal',
    props:{
      showModalMessager:true
    },
    methods:{
        closeMesage(){
            this.$emit('closeMessager');
        },
        moveToPage(){
          this.$emit('moveToPage');
        }
    },
    created(){
      console.log(this.showModalMessager);
    }

}
</script>
<style scoped>
/* image modal */
.modal-mask {
  position: fixed;
  z-index: 9998 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>